import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue';
import { computed, ref } from 'vue';
import Avatar from './Avatar.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'AvatarStack',
    props: {
        users: {
            type: Array,
            default: () => [],
        },
        totalSlots: { type: Number, default: 0 },
        maxWidthInPx: { type: Number, default: 200 },
        size: { type: Number, default: 35 },
        overlap: { type: Number, default: 0.4 },
        showOverflowTooltip: { type: Boolean, default: true },
        joinedTooltip: { type: Boolean, default: false },
        variant: { type: String, default: 'default' },
    },
    setup(__props) {
        const props = __props;
        _useCssVars((_vm, _setup) => ({
            "c04fe998": (_setup.backgroundColor),
            "30942a5a": (_setup.overlapInPx + 'px'),
            "cbe7632a": (_setup.contentColor),
            "745095d6": (_setup.slotBackgroundColor),
            "732c914b": (_vm.size + 'px')
        }));
        const hidden = ref(null);
        const overlapInPx = computed(() => Math.round(props.size * props.overlap));
        const availableCirclesCount = computed(() => Math.max(1, Math.floor((props.maxWidthInPx - overlapInPx.value) / (props.size - overlapInPx.value))));
        const totalSlotsCount = computed(() => Math.max(props.totalSlots, props.users.length));
        const overflowingSlotsCount = computed(() => totalSlotsCount.value > availableCirclesCount.value
            ? totalSlotsCount.value - availableCirclesCount.value + 1
            : 0);
        const freeSlotsCount = computed(() => Math.max(0, props.totalSlots - props.users.length));
        const shownSlotCounts = computed(() => {
            let freeCircles = availableCirclesCount.value;
            if (overflowingSlotsCount.value)
                --freeCircles;
            let shownFreeSlotsCount = 0;
            if (freeSlotsCount.value > 0) {
                shownFreeSlotsCount = 1;
                freeCircles--;
            }
            const shownUserSlotsCount = Math.max(props.users.length ? 1 : 0, Math.min(freeCircles, props.users.length));
            freeCircles -= shownUserSlotsCount;
            shownFreeSlotsCount = Math.max(shownFreeSlotsCount, Math.min(freeSlotsCount.value, freeCircles + 1));
            return {
                users: shownUserSlotsCount,
                free: shownFreeSlotsCount,
            };
        });
        const shownUsers = computed(() => props.users.slice(0, shownSlotCounts.value.users).reverse());
        const hiddenUsers = computed(() => props.users.slice(shownSlotCounts.value.users));
        const contentColor = computed(() => props.variant === 'default'
            ? 'var(--fs-color-primary-700)'
            : `var(--fs-color-${props.variant}-500)`);
        const slotBackgroundColor = computed(() => props.variant === 'default'
            ? 'var(--fs-color-primary-200)'
            : `var(--fs-color-${props.variant}-300)`);
        const backgroundColor = computed(() => props.variant === 'default'
            ? 'white'
            : `var(--fs-color-${props.variant}-500)`);
        return { __sfc: true, props, hidden, overlapInPx, availableCirclesCount, totalSlotsCount, overflowingSlotsCount, freeSlotsCount, shownSlotCounts, shownUsers, hiddenUsers, contentColor, slotBackgroundColor, backgroundColor, Avatar };
    }
});
